module.exports = __webpack_public_path__ + "static/media/meishaonvhaigo.a214226d.png";